import React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';

function TATransactionAccountInfo({
  t,
  accountNumber,
  companyName,
  registrationCode,
}) {
  TATransactionAccountInfo.propTypes = {
    t: PropTypes.func.isRequired,
    accountNumber: PropTypes.string,
    companyName: PropTypes.string,
    registrationCode: PropTypes.string,
  };
  return (
    <Row className="global-margin-bottom-10" gutter={[16, 16]}>
      <Col span={8}>
        <div>
          <strong>{t('gosAccountInfo.accountNumber')}:</strong>
        </div>
        <div>{accountNumber}</div>
      </Col>
      <Col span={8}>
        <div>
          <strong>{t('gosAccountInfo.name')}:</strong>
        </div>
        <div>{companyName}</div>
      </Col>
      <Col span={8}>
        <div>
          <strong>{t('gosAccountInfo.registrationCode')}:</strong>
        </div>
        <div>{registrationCode}</div>
      </Col>
    </Row>
  );
}

export default TATransactionAccountInfo;
